import { useCallback, useRef } from 'react';

import type { Transaction } from 'prosemirror-state';

export const useTranscriptionToEditorText = () => {
	const interimTextRef = useRef<{ from: number; to: number; text: string } | null>(null);

	const handleTranscriptUpdate = useCallback(
		(transcript: string, tr: Transaction, isFinal?: boolean) => {
			const { selection } = tr;
			let pos = selection.$head.pos;

			if (interimTextRef.current) {
				tr.delete(interimTextRef.current.from, interimTextRef.current.to);
				if (interimTextRef.current.from < pos) {
					pos -= interimTextRef.current.to - interimTextRef.current.from;
				}
				interimTextRef.current = null;
			}

			if (isFinal) {
				tr.insertText(`${transcript} `, pos);
			} else if (transcript) {
				tr.insertText(transcript, pos);
				interimTextRef.current = {
					from: pos,
					to: pos + transcript.length,
					text: transcript,
				};
			}

			return tr;
		},
		[],
	);

	return { handleTranscriptUpdate };
};
